// extracted by mini-css-extract-plugin
module.exports = {"edit":"_1vZy4"};